import { GetterTree } from 'vuex'
import { ModuleState } from './types'
import { RootState } from '@/types'

export const getters: GetterTree<ModuleState, RootState> = {
  towns(state) { return state.towns },
  townByName: (state) => (uniqueName: string) => {
    if(Object.keys(state.towns).includes(uniqueName))
      return state.towns[uniqueName]
    return {}
  },
  townById: (state) => (id: number) => {
    const maybeTown = Object.values(state.towns).find(town => town.id === id)
    return maybeTown ? maybeTown : {}
  },
  townIdFromName: (state) => (uniqueName: string) => {
    if(Object.keys(state.towns).includes(uniqueName))
      return state.towns[uniqueName].id
    return ''
  },
  townHotwords: (state) => (townId: number) => {
    if(Object.keys(state.hotwords).includes(townId.toString())) {
      return state.hotwords[townId]
    }
    return []
  },
  townNotices: (state) => (townId: number) => {
    if(Object.keys(state.notices).includes(townId.toString()))
      return state.notices[townId]
    return []
  }
}
